import { useInView } from '../hooks';
import styles from './Chart.module.css';

const CHAIN = 'ton';
const PAIR  = 'eqcwb0pvsrkxbiyw_h5rqatiepwfvnmqv_l7vdmmo7fgwfvo';

export default function Chart({ t }) {
  const [ref, inView] = useInView(0.1);

  return (
    <section className={styles.section} id="chart">
      <div className={styles.inner}>
        <div
          ref={ref}
          style={{ opacity: inView ? 1 : 0, transform: inView ? 'none' : 'translateY(16px)', transition: 'all 0.6s ease' }}
        >
          <div className={styles.label}>{t.sectionLabel}</div>
          <h2 className={styles.title}>{t.title}</h2>
          <p className={styles.sub}>{t.sub}</p>
        </div>

        <div className={styles.chartWrap}>
          <iframe
            title="APX/GRAM Chart"
            src={`https://dexscreener.com/${CHAIN}/${PAIR}?embed=1&theme=dark&trades=0&info=0`}
            className={styles.iframe}
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}
